import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex justify-between items-start mb-2"
};
const _hoisted_2 = {
  class: "flex-1 pr-2"
};
const _hoisted_3 = {
  class: "text-lg font-semibold leading-tight"
};
const _hoisted_4 = {
  class: "flex items-center space-x-2"
};
const _hoisted_5 = {
  class: "grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-gray-700 mb-2"
};
const _hoisted_6 = {
  class: "flex items-center"
};
const _hoisted_7 = {
  class: "truncate"
};
const _hoisted_8 = {
  class: "flex items-center"
};
const _hoisted_9 = {
  class: "truncate"
};
const _hoisted_10 = {
  class: "flex items-center"
};
const _hoisted_11 = {
  class: "truncate"
};
const _hoisted_12 = {
  class: "flex items-center"
};
const _hoisted_13 = {
  class: "truncate"
};
const _hoisted_14 = {
  class: "flex items-center"
};
const _hoisted_15 = {
  class: "flex items-center"
};
const _hoisted_16 = {
  key: 0,
  class: "grid grid-cols-2 gap-2 text-sm text-gray-700 mb-2"
};
const _hoisted_17 = {
  class: "flex items-center"
};
const _hoisted_18 = {
  class: "flex items-center"
};
const _hoisted_19 = {
  key: 1,
  class: "grid grid-cols-2 gap-2 text-sm text-gray-700 mb-2"
};
const _hoisted_20 = {
  key: 0,
  class: "flex items-center"
};
const _hoisted_21 = {
  key: 1,
  class: "flex items-center"
};
const _hoisted_22 = {
  key: 2,
  class: "grid grid-cols-2 gap-2 text-sm text-gray-700 mb-2"
};
const _hoisted_23 = {
  key: 0,
  class: "flex items-center"
};
const _hoisted_24 = {
  key: 1,
  class: "flex items-center"
};
const _hoisted_25 = {
  class: "flex justify-end items-center text-sm text-gray-700 mb-2"
};
const _hoisted_26 = {
  key: 0,
  class: "flex items-center"
};
const _hoisted_27 = {
  key: 3,
  class: "flex items-center text-sm text-gray-700 mb-2"
};
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  key: 4,
  class: "mt-2 text-sm text-gray-600 border-t pt-2"
};
const _hoisted_30 = {
  class: "flex items-start"
};
import { useBillingTypeLabel } from '@/composables/useBillingTypeLabel';
import { useMarkAsBilled } from '@/composables/useMarkAsBilled';
import { getShortDateString } from '@/services/utils';
import { useMeStore } from '@/services/UserService/useMeStore';
import { storeToRefs } from 'pinia';
import LlTooltip from '@/components/LlTooltip.vue';
export default {
  __name: 'TimeEntryCard',
  props: {
    entry: {
      type: Object,
      required: true
    },
    showStartStopTimes: {
      type: Boolean,
      default: false
    },
    stripDescription: {
      type: Boolean,
      default: false
    },
    showNotes: {
      type: Boolean,
      default: false
    },
    showTaskCodes: {
      type: Boolean,
      default: false
    },
    showActivityCodes: {
      type: Boolean,
      default: false
    },
    showFixedFeeColumn: {
      type: Boolean,
      default: true
    },
    hideActions: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['click', 'duplicate', 'delete', 'openNotes'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      billingTypeLabel
    } = useBillingTypeLabel();
    const {
      features
    } = storeToRefs(useMeStore());
    const emit = __emit;
    const props = __props;
    const {
      canMarkUnmarkEntry,
      handleMarkAsBilled
    } = useMarkAsBilled(props.filter);
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_list_item_title = _resolveComponent("v-list-item-title");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_menu = _resolveComponent("v-menu");
      const _component_v_chip = _resolveComponent("v-chip");
      return _openBlock(), _createElementBlock("div", {
        class: "p-4 rounded-lg shadow-md bg-white",
        onClick: _cache[4] || (_cache[4] = $event => _ctx.$emit('click', $event))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h3", _hoisted_3, _toDisplayString(__props.stripDescription ? __props.entry.shortDescription : __props.entry.description), 1)]), _createElementVNode("div", _hoisted_4, [!__props.hideActions ? (_openBlock(), _createBlock(_component_v_menu, {
        key: 0
      }, {
        activator: _withCtx(({
          props
        }) => [_createVNode(_component_v_icon, _mergeProps(props, {
          class: "text-gray-400",
          size: "small",
          "data-cy": "entry-actions-menu"
        }), {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("mdi-dots-vertical", -1)]))]),
          _: 1
        }, 16)]),
        default: _withCtx(() => [_createVNode(_component_v_list, null, {
          default: _withCtx(() => [_createVNode(_component_v_list_item, {
            onClick: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.$emit('duplicate', __props.entry), ["stop"])),
            "data-cy": "duplicate-entry-menu-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("Duplicate Entry", -1)]))]),
              _: 1
            })]),
            _: 1
          }), _unref(canMarkUnmarkEntry)(__props.entry) ? (_openBlock(), _createBlock(_component_v_list_item, {
            key: 0,
            onClick: _cache[1] || (_cache[1] = _withModifiers($event => _unref(handleMarkAsBilled)(__props.entry), ["stop"])),
            "data-cy": "mark-unmark-billed-menu-item"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.entry.billed ? 'Unmark as Billed' : 'Mark as Billed'), 1)]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_v_list_item, {
            onClick: _cache[2] || (_cache[2] = _withModifiers($event => _ctx.$emit('delete', __props.entry), ["stop"]))
          }, {
            default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("Delete Entry", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(LlTooltip, {
        text: "Date",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          class: "text-gray-400 mr-1",
          size: "small"
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("mdi-calendar", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(features).dateHandling ? _unref(getShortDateString)(__props.entry.date) : __props.entry.date), 1)]), _createElementVNode("div", _hoisted_8, [_createVNode(LlTooltip, {
        text: "Timekeeper",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("mdi-account", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", _hoisted_9, _toDisplayString(__props.entry.timekeeper), 1)]), _createElementVNode("div", _hoisted_10, [_createVNode(LlTooltip, {
        text: "Client",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("mdi-briefcase", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", _hoisted_11, _toDisplayString(__props.entry.client), 1)]), _createElementVNode("div", _hoisted_12, [_createVNode(LlTooltip, {
        text: "Matter",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("mdi-file-document", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", _hoisted_13, _toDisplayString(__props.entry.matter), 1)]), _createElementVNode("div", _hoisted_14, [_createVNode(LlTooltip, {
        text: "Hours",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("mdi-clock-time-four-outline", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", null, _toDisplayString(__props.entry.hours), 1)]), _createElementVNode("div", _hoisted_15, [_createVNode(LlTooltip, {
        text: "Billing Type",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("mdi-tag-outline", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", null, _toDisplayString(_unref(billingTypeLabel)(__props.entry)), 1)])]), __props.showStartStopTimes && (__props.entry.startTime || __props.entry.endTime) ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(LlTooltip, {
        text: "Start Time",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("mdi-play", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", null, _toDisplayString(__props.entry.startTime || 'N/A'), 1)]), _createElementVNode("div", _hoisted_18, [_createVNode(LlTooltip, {
        text: "End Time",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("mdi-stop", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", null, _toDisplayString(__props.entry.endTime || 'N/A'), 1)])])) : _createCommentVNode("", true), __props.showTaskCodes && __props.entry.codes?.task?.id || __props.showActivityCodes && __props.entry.codes?.activity?.id ? (_openBlock(), _createElementBlock("div", _hoisted_19, [__props.showTaskCodes && __props.entry.codes?.task?.id ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(LlTooltip, {
        text: "Task Code",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("mdi-clipboard-list", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", null, _toDisplayString(__props.entry.codes.task.id), 1)])) : _createCommentVNode("", true), __props.showActivityCodes && __props.entry.codes?.activity?.id ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(LlTooltip, {
        text: "Activity Code",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("mdi-account-cog", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", null, _toDisplayString(__props.entry.codes.activity.id), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), __props.entry.rate || __props.entry.amount ? (_openBlock(), _createElementBlock("div", _hoisted_22, [__props.entry.billingType === 'billable' ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(LlTooltip, {
        text: "Rate",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("mdi-currency-usd", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", null, _toDisplayString(__props.entry.rate || 'N/A'), 1)])) : _createCommentVNode("", true), __props.entry.billingType === 'billable' ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(LlTooltip, {
        text: "Amount",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("mdi-cash-multiple", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("span", null, _toDisplayString(__props.entry.amount || 'N/A'), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_25, [__props.entry.customFlag !== undefined ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(LlTooltip, {
        text: "Lobbying",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1",
          color: __props.entry.customFlag ? 'primary' : 'error'
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.entry.customFlag ? 'mdi-check-circle' : 'mdi-close-circle'), 1)]),
          _: 1
        }, 8, ["color"])]),
        _: 1
      }), _cache[20] || (_cache[20] = _createElementVNode("span", null, "Lobbying", -1))])) : _createCommentVNode("", true)]), __props.showFixedFeeColumn && (__props.entry.charge || __props.entry.billingType === 'fixedFee') ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(LlTooltip, {
        text: "Fixed Fee",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("mdi-file-document-outline", -1)]))]),
          _: 1
        })]),
        _: 1
      }), __props.entry.charge ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(__props.entry.charge.label || __props.entry.charge.description), 1)) : (_openBlock(), _createBlock(_component_v_chip, {
        key: 1,
        color: "orange",
        size: "small"
      }, {
        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("Unassigned", -1)]))]),
        _: 1
      }))])) : _createCommentVNode("", true), __props.showNotes && __props.entry.note ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(LlTooltip, {
        text: "Internal Notes",
        location: "start"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          size: "small",
          class: "mr-1 mt-0.5 cursor-pointer",
          onClick: _cache[3] || (_cache[3] = _withModifiers($event => _ctx.$emit('openNotes', __props.entry), ["stop"]))
        }, {
          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode(" mdi-message-outline ", -1)]))]),
          _: 1
        })]),
        _: 1
      }), _cache[24] || (_cache[24] = _createElementVNode("span", {
        class: "text-xs text-gray-500"
      }, "Has notes", -1))])])) : _createCommentVNode("", true)]);
    };
  }
};